/**
 * Ano da LOA (Lei Orçamentária Anual) estimado a partir da data de referência.
 *
 * Ofício expedido:
 * - até 1º de fevereiro do ano Y → LOA Y+1
 * - a partir de 2 de fevereiro do ano Y → LOA Y+2
 *
 * Direito creditório (sem data de expedição): um ano a mais que o ofício.
 * - até 1º de fevereiro do ano Y → LOA Y+2
 * - a partir de 2 de fevereiro do ano Y → LOA Y+3
 */
export function resolveLoaYear(tipoProduto, referenceDate = new Date()) {
  const date = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const afterFebruaryFirst = month > 1 || (month === 1 && day >= 2);
  const isOficio = tipoProduto === "OFICIO_EXPEDIDO";

  if (isOficio) {
    return afterFebruaryFirst ? year + 2 : year + 1;
  }

  return afterFebruaryFirst ? year + 3 : year + 2;
}

export function formatLoaLabel(tipoProduto, referenceDate = new Date()) {
  const year = resolveLoaYear(tipoProduto, referenceDate);
  if (!year) return null;
  return `LOA ${year}`;
}
